export const env = {
  NODE_ENV: (import.meta.env.MODE as string | undefined) ?? 'development',
  VITE_APP_NAME: (import.meta.env.VITE_APP_NAME as string | undefined) ?? 'Tool No Hu',
  VITE_API_URL: (import.meta.env.VITE_API_URL as string | undefined) ?? 'http://localhost:4000',
} as const;

export const siteConfig = {
  name: env.VITE_APP_NAME,
  description: 'Tool No Hu management interface',
  apiUrl: env.VITE_API_URL,
} as const;
